export enum QuoteTotalLayouts {
  SUMMARY = 'summary',
  COLLAPSED = 'collapsed',
  EXTENDED = 'extended',
}
